

define(['squid/index', 'text!./template.html', 'components/xo-models/src/user/index'], function (squid, template) {

    squid.module('xo-escape-hatch.closeFrame.directive', ['squid', 'xomodel.user']).directive('xoCloseFrame', function () {
        return {
            template: template,

            restrict: 'E',

            scope: {
                redirectiframe: '=',
                redirectLightbox: '='
            },

            controller: function controller($scope, $rootScope, $populate, $CheckoutInputDataModel, $window, $CheckoutAppDataModel, $util, $injector, $logger, $ReturnToMerchant) {

                $populate($scope, {
                    checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token)
                }).then(function () {
                    var cancel_url = $scope.checkoutAppData.urls.cancel_url;

                    $scope.checkoutInputData = $CheckoutInputDataModel.instance($scope.token);
                    $scope.isIFrame = $util.isIFrame();

                    $scope.closeFrame = function (event) {
                        event.preventDefault();
                        event.stopPropagation();

                        if (window.xchild) {
                            if (window.xprops.onCancel) {
                                return window.xprops.onCancel({
                                    token: $scope.token,
                                    cancelUrl: cancel_url
                                });
                            } else {
                                return window.xchild.close();
                            }
                        }

                        if ($scope.redirectLightbox) {
                            var result = $ReturnToMerchant.postToMerchant({
                                operation: 'return_to_merchant',
                                returnUrl: cancel_url,
                                updateParent: true
                            });

                            // Otherwise we have no choice but to return to the merchant
                            if (!result) {
                                $util.redirect(cancel_url);
                            }

                            // TODO - Move out helios specific logic. Apps should provide a callback instead.
                        } else if ($scope.redirectiframe) {
                            $window.location.replace(cancel_url);

                            // TODO - Move out helios specific logic. Apps should provide a callback instead.
                        } else {

                            var iFrameFlow = $injector.get('$IFrameFlow');

                            $logger.info('HELIOS_FLOW_FALLBACK'); // overall fallbacks
                            $logger.info('HELIOS_FALLBACK_TO_MERCHANT');
                            $logger.info('HELIOS_FALLBACK_MERCHANT_USER_CANCELLED');

                            var url = $scope.checkoutInputData.errorUrl('user_cancelled');

                            if ($scope.auth && $scope.auth.code) {
                                url += '&code=' + $scope.auth.code;
                            }

                            iFrameFlow.findWindowAndRedirect($scope.checkoutInputData, url);
                        }
                        $scope.$emit('exitFrame');
                    };
                });
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-ui-components/src/escape-hatch/closeFrame/directive.js
// module id = ./components/xo-ui-components/src/escape-hatch/closeFrame/directive.js
// module chunks = 1